import { jsx } from "react/jsx-runtime";
import React from "react";
import { MenuItem } from "@blueprintjs/core";
import tgUseLocalStorageState from "tg-use-local-storage-state";
const useAnnotationLimits = () => tgUseLocalStorageState("annotationLimits", {
  defaultValue: {
    features: 1e4,
    parts: 50,
    primers: 50,
    warnings: 50,
    assemblyPieces: 50,
    lineageAnnotations: 50,
    cutsites: 100
  }
});
export default useAnnotationLimits;
export function LimitAnnotations({ type, ...rest }) {
  const [limits = {}, setLimits] = useAnnotationLimits();
  return /* @__PURE__ */ jsx(MenuItem, { icon: "blank", shouldDismissPopover: false, ...rest, children: [50, 100, 200, 400].map((n) => /* @__PURE__ */ jsx(
    MenuItem,
    {
      shouldDismissPopover: false,
      icon: (!limits[type] ? n === 50 : limits[type] === n) ? "small-tick" : "blank",
      text: n,
      onClick: () => setLimits({ ...limits, [type]: n })
    },
    n
  )) });
}
